import { useNavigate } from 'react-router-dom';
import { Button, Card, EmptyState } from '../components/common';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Card>
      <EmptyState
        title="Page not found"
        message="That address does not match any screen in the portal."
        action={<Button onClick={() => navigate('/')}>Back to the dashboard</Button>}
      />
    </Card>
  );
}
